module.exports = __webpack_public_path__ + "img/pic_xifashui2.363fe0ec.png";